<template>
	<div class="card-v2 card-partners">
		<header class="flex-split mb-8 lg-mb-16">
			<h3 class="m0">Partner Resources</h3>
			<router-link :to="{ name: $routes.Resources.name }" class="show-xl fs-12">View All Resources</router-link>
		</header>
		<div
			v-for="(
				{ name, url, imageUrl, description, couponCode, couponCodeDescription }, index
			) in partners"
			:key="`partner-${index}`"
			class="flex pad-16 border-bottom-07"
		>
			<a :href="url" target="_blank" class="mr-16 border square-60 no-overflow flex-center pad-4">
				<img :src="imageUrl" :alt="`${name} logo`" class="block" />
			</a>
			<div>
				<a :href="url" target="_blank" class="fs-14 fw-700 m0 violet-link block">{{ name }}</a>
				<p
					v-for="(paragraph, paragraphIndex) in toParagraphs(description)"
					:key="`partner-${index}-description-${paragraphIndex}`"
					class="fs-12 mt-8"
				>
					{{ paragraph }}
				</p>
				<p v-if="couponCode" class="fs-12 mt-8">
					Coupon Code: <span class="fw-700 no-wrap">{{ couponCode }}</span>
					{{ couponCodeDescription }}
				</p>
			</div>
		</div>
		<div class="hide-xl border-top-07 pt-16">
			<router-link :to="{ name: $routes.Resources.name }" class="fs-12">View All Resources</router-link>
		</div>
	</div>	
</template>

<script>
import { toParagraphs } from '@/helpers/convert';
import partners from '@/helpers/partners';

export default {
	name: 'CardPartnerResources',
  computed: {
    partners() {
      return partners;
    },
  },
  methods: {
    toParagraphs,
  },
}
</script>
